import styled from 'styled-components';

export const PaymentPending = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MessageTitle = styled.h1`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  color: var(--v3-text-color);
  text-align: center;
`;

export const MessageSubtitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--v3-text-color);
  text-align: center;
`;
